import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, CreditCard, Calendar, Bell, User } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useLive } from "./LiveFeed";

const TABS = [
  { to: "/portal", end: true, icon: LayoutDashboard, label: "Home", id: "dashboard" },
  { to: "/portal/dues", icon: CreditCard, label: "Dues", id: "dues" },
  { to: "/portal/events", icon: Calendar, label: "Events", id: "events" },
  { to: "/portal/notifications", icon: Bell, label: "Alerts", id: "notifications" },
  { to: "/portal/profile", icon: User, label: "Profile", id: "profile" },
];

const cls = ({ isActive }) => `relative flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors ${
  isActive ? "text-gold" : "text-parchment/70 active:text-parchment"}`;

export function BottomTabBar() {
  const { t } = useLang();
  const { unread } = useLive();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 flex border-t border-gold/30 bg-slate-950/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden" aria-label="Primary" data-testid="bottom-tab-bar">
      {TABS.map((tab) => (
        <NavLink key={tab.to} to={tab.to} end={tab.end} className={cls} data-testid={`tab-${tab.id}`}>
          <span className="relative">
            <tab.icon size={22} />
            {tab.id === "notifications" && unread > 0 && (
              <span className="absolute -right-2.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-crimson px-1 text-[10px] font-bold leading-none text-parchment" data-testid="tab-unread-badge">{unread > 99 ? "99+" : unread}</span>
            )}
          </span>
          {t(tab.label)}
        </NavLink>
      ))}
    </nav>
  );
}
